import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";

const { default: sheet } = CSS_MODULE_SCRIPTS
	? await import("./link.module.css", { with: { type: "css" } })
	: await importCss("./link.module.css", import.meta.url);
export default adopt(sheet);
